import { StyleSheet } from 'react-native'

export const themedButtonContainerStyle = StyleSheet.create({
	view: {
		width: 'auto'
	},
	viewFill: {
		flex: 1,
		width: '100%'
	}
})
